import { API } from "../core/config";
import client from "../core/http/client";
import { Preferences, PreferencesUpdateRequest } from "../models/preference";
import { ApiResponse } from "../shared/types/api";

class PreferencesApi {
    async getPreferences(): Promise<ApiResponse<Preferences>> {
        // console.log('[PreferencesApi] getPreferences appelé');
        try {
            const response = await client.get<ApiResponse<Preferences>>(API.ACCOUNT.PREFERENCES);
            // console.log('[PreferencesApi] getPreferences réponse :', response.data);
            return response.data;
        } catch (error) {
            // console.error('[PreferencesApi] getPreferences erreur :', error);
            throw error;
        }
    }

    async updatePreferences(data: PreferencesUpdateRequest): Promise<ApiResponse<Preferences>> {
        const response = await client.patch<ApiResponse<Preferences>>(API.ACCOUNT.PREFERENCES, data);
        return response.data;
    }
}

export const preferencesApi = new PreferencesApi();